import { render, staticRenderFns } from "./activityResourcePage.vue?vue&type=template&id=6baa09ca&"
import script from "./activityResourcePage.vue?vue&type=script&lang=js&"
export * from "./activityResourcePage.vue?vue&type=script&lang=js&"
import style0 from "./activityResourcePage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports